export default __webpack_public_path__ + "static/media/operation.8455b798.jpg";